
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Table,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap"
import { connect } from "react-redux"
import { useParams } from "react-router-dom"

//Import Action
import {
    setBreadcrumbItems,
    getCompanyDetail,
    getPlans,
    assignPlan
} from "../../../store/actions"

import { createSubscriptionForCompany } from "../../../helpers/fakebackend_helper"
import { toast } from "react-toastify"
import CompanyUsersManager from "./CompanyUsersManager"

const CompanyDetail = (props) => {
    const { id } = useParams()
    const [modal, setModal] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState("")
    const [activateNow, setActivateNow] = useState(true)
    const [paymentMethod, setPaymentMethod] = useState("")
    const [paymentRef, setPaymentRef] = useState("")
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        props.getCompanyDetail(id)
        props.getPlans()
    }, [id])

    const { companyDetail, plans } = props

    useEffect(() => {
        if (companyDetail) {
            const breadcrumbItems = [
                { title: "CRM", link: "#" },
                { title: "Entreprises", link: "/admin/companies" },
                { title: companyDetail.name, link: "#" },
            ]
            props.setBreadcrumbItems(companyDetail.name, breadcrumbItems)
        }
    }, [companyDetail])

    const toggleModal = () => {
        setModal(!modal)
        if (!modal) {
            setSelectedPlan("")
            setActivateNow(true)
            setPaymentMethod("")
            setPaymentRef("")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!selectedPlan) {
            toast.error("Veuillez sélectionner un plan")
            return
        }

        setLoading(true)
        try {
            const data = {
                company_id: id,
                plan_id: selectedPlan,
                activate_immediately: activateNow
            }

            if (activateNow && paymentMethod) {
                data.payment_method = paymentMethod
                data.payment_reference = paymentRef
            }

            await createSubscriptionForCompany(data)
            toast.success(activateNow ? "Abonnement créé et activé !" : "Abonnement créé en attente de paiement")
            toggleModal()
            props.getCompanyDetail(id)
        } catch (error) {
            toast.error("Erreur lors de la création")
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    if (!companyDetail) {
        return <div className="text-center p-5">Chargement...</div>
    }

    return (
        <React.Fragment>
            <Row>
                <Col xl="4">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Informations Générales</CardTitle>
                            <div className="text-center mb-4">
                                <div className="avatar-md mx-auto mb-4">
                                    <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-24">
                                        {companyDetail.name.charAt(0)}
                                    </span>
                                </div>
                                <h5 className="font-size-16">{companyDetail.name}</h5>
                                <p className="text-muted">{companyDetail.email}</p>
                            </div>

                            <div className="table-responsive">
                                <Table className="table-nowrap mb-0">
                                    <tbody>
                                        <tr>
                                            <th scope="row">UUID:</th>
                                            <td>{companyDetail.uuid}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Téléphone:</th>
                                            <td>{companyDetail.phone || "N/A"}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Statut:</th>
                                            <td>
                                                <span className={companyDetail.status === 'active' ? 'badge badge-soft-success font-size-12 px-2 py-1' : 'badge badge-soft-danger font-size-12 px-2 py-1'}>
                                                    {companyDetail.status === 'active' ? 'Actif' : 'Inactif'}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Date Création:</th>
                                            <td>{new Date(companyDetail.created_at).toLocaleDateString()}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>

                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <CardTitle className="h4 mb-0">Abonnement</CardTitle>
                                <Button color="primary" size="sm" onClick={toggleModal}>
                                    <i className="mdi mdi-plus me-1"></i> Gérer
                                </Button>
                            </div>

                            {companyDetail.subscription ? (
                                <div className="p-3 bg-soft-primary rounded border border-soft-primary">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="avatar-xs me-3">
                                            <span className="avatar-title rounded-circle bg-primary text-white font-size-18">
                                                <i className="mdi mdi-crown"></i>
                                            </span>
                                        </div>
                                        <h6 className="text-primary font-size-16 mb-0">
                                            {companyDetail.subscription.plan?.name}
                                        </h6>
                                    </div>
                                    <div className="mt-3">
                                        <div className="text-muted mb-2 font-size-13 d-flex justify-content-between align-items-center">
                                            <span>Statut:</span>
                                            <span className="badge badge-soft-success font-size-12 px-2 py-1">
                                                {companyDetail.subscription.status === 'active' ? 'Actif' : companyDetail.subscription.status}
                                            </span>
                                        </div>
                                        <div className="text-muted mb-0 font-size-13 d-flex justify-content-between align-items-center">
                                            <span>Expiration:</span>
                                            <span className="fw-bold text-dark">
                                                {new Date(companyDetail.subscription.ends_at).toLocaleDateString()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center p-3 border border-dashed rounded text-muted italic">
                                    Aucun abonnement actif
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>

                <Col xl="8">
                    <Row>
                        <Col md="6">
                            <Card>
                                <CardBody className="text-center">
                                    <div className="avatar-sm mx-auto mb-3">
                                        <span className="avatar-title rounded-circle bg-soft-info text-info font-size-18">
                                            <i className="mdi mdi-account-group"></i>
                                        </span>
                                    </div>
                                    <h5>{companyDetail.users_count || 0}</h5>
                                    <p className="text-muted mb-0">Utilisateurs</p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6">
                            <Card>
                                <CardBody className="text-center">
                                    <div className="avatar-sm mx-auto mb-3">
                                        <span className="avatar-title rounded-circle bg-soft-warning text-warning font-size-18">
                                            <i className="mdi mdi-account-network"></i>
                                        </span>
                                    </div>
                                    <h5>{companyDetail.customers_count || 0}</h5>
                                    <p className="text-muted mb-0">Clients CRM</p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <CompanyUsersManager companyId={id} />
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>Créer un Abonnement</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup className="mb-3">
                            <Label for="planSelect">Choisir un Plan <span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                id="planSelect"
                                value={selectedPlan}
                                onChange={(e) => setSelectedPlan(e.target.value)}
                                required
                            >
                                <option value="">Sélectionnez un plan...</option>
                                {(plans || []).map(plan => (
                                    <option key={plan.id} value={plan.id}>
                                        {plan.name} - ${plan.price} ({plan.duration_months} mois)
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <div className="form-check form-switch">
                                <Input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="activateNow"
                                    checked={activateNow}
                                    onChange={(e) => setActivateNow(e.target.checked)}
                                />
                                <Label className="form-check-label" for="activateNow">
                                    Activer immédiatement
                                    <small className="text-muted d-block">Si décoché, l'abonnement sera créé en attente de paiement</small>
                                </Label>
                            </div>
                        </FormGroup>

                        {activateNow && (
                            <>
                                <div className="alert alert-info">
                                    <i className="mdi mdi-information-outline me-2"></i>
                                    <strong>Activation immédiate :</strong> L'abonnement sera actif dès maintenant
                                </div>

                                <Row>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label for="paymentMethod">Mode de Paiement</Label>
                                            <Input
                                                type="select"
                                                id="paymentMethod"
                                                value={paymentMethod}
                                                onChange={(e) => setPaymentMethod(e.target.value)}
                                            >
                                                <option value="">Sélectionner...</option>
                                                <option value="cash">Espèces</option>
                                                <option value="bank_transfer">Virement Bancaire</option>
                                                <option value="check">Chèque</option>
                                                <option value="mobile_money">Mobile Money</option>
                                                <option value="other">Autre</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup className="mb-3">
                                            <Label for="paymentRef">Référence de Paiement</Label>
                                            <Input
                                                type="text"
                                                id="paymentRef"
                                                placeholder="Ex: VIRT-2026-001"
                                                value={paymentRef}
                                                onChange={(e) => setPaymentRef(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </>
                        )}

                        <div className="text-end mt-4">
                            <Button type="button" color="secondary" onClick={toggleModal} className="me-2">
                                Annuler
                            </Button>
                            <Button type="submit" color="primary" disabled={loading}>
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Création...
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-check me-1"></i>
                                        {activateNow ? "Créer & Activer" : "Créer en Attente"}
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        companyDetail: state.Companies.companyDetail,
        plans: state.Plans.plans,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getCompanyDetail,
    getPlans,
    assignPlan
})(CompanyDetail)
